// consts
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';

// Constantes para os valores da bateria
const CONCENTRATOR_MIN_VOLTAGE = 3;
const CONCENTRATOR_VOLTAGE_RANGE = 1.2;

// Constantes para os pontos de corte de tensão do dispositivo padrão
const DEFAULT_MAX_VOLTAGE = 4.3;
const DEFAULT_HIGH_VOLTAGE_THRESHOLD = 3.8;
const DEFAULT_MEDIUM_VOLTAGE_THRESHOLD = 3.7;

// Constantes para as taxas de conversão de tensão para porcentagem
const DEFAULT_HIGH_RATE = 160;
const DEFAULT_MEDIUM_RATE = 50;
const DEFAULT_LOW_RATE = 30;

// Constantes para os pontos de porcentagem de capacidade
const DEFAULT_HIGH_CAPACITY_POINT = 100;
const DEFAULT_MEDIUM_CAPACITY_POINT = 20;
const DEFAULT_LOW_CAPACITY_POINT = 15;

/**
 * Calcula a capacidade da bateria para um dispositivo CONCENTRATOR.
 * @param {number} batteryVoltage - A tensão da bateria.
 * @returns {number} A capacidade da bateria em porcentagem (0-100).
 */
const calculateConcentratorCapacity = batteryVoltage => {
  const rawCapacity = batteryVoltage - CONCENTRATOR_MIN_VOLTAGE;
  let capacity = (100 * rawCapacity) / CONCENTRATOR_VOLTAGE_RANGE;

  return Math.max(0, Math.min(100, Math.round(capacity)));
};

/**
 * Calcula a capacidade da bateria para um dispositivo padrão.
 * @param {number} batteryVoltage - A tensão da bateria.
 * @returns {number} A capacidade da bateria em porcentagem (0-100).
 */
const calculateDefaultCapacity = batteryVoltage => {
  let capacity;

  if (batteryVoltage > DEFAULT_HIGH_VOLTAGE_THRESHOLD) {
    capacity = DEFAULT_HIGH_CAPACITY_POINT - (DEFAULT_MAX_VOLTAGE - batteryVoltage) * DEFAULT_HIGH_RATE;
  } else if (batteryVoltage > DEFAULT_MEDIUM_VOLTAGE_THRESHOLD) {
    capacity = DEFAULT_MEDIUM_CAPACITY_POINT - (DEFAULT_HIGH_VOLTAGE_THRESHOLD - batteryVoltage) * DEFAULT_MEDIUM_RATE;
  } else {
    capacity = DEFAULT_LOW_CAPACITY_POINT - (DEFAULT_MEDIUM_VOLTAGE_THRESHOLD - batteryVoltage) * DEFAULT_LOW_RATE;
  }

  return Math.max(0, Math.min(100, Math.round(capacity)));
};

/**
 * Retorna o estado da bateria em porcentagem para um tipo de dispositivo.
 * @param {number} batteryVoltage - A tensão da bateria.
 * @param {string} deviceType - O tipo de dispositivo (ex: DEVICE_TYPE.CONCENTRATOR).
 * @returns {string} O estado da bateria formatado como uma string (ex: "85%").
 */
const getBatteryState = (batteryVoltage, deviceType) => {
  let capacity;

  switch (deviceType) {
    case DEVICE_TYPE.CONCENTRATOR:
      capacity = calculateConcentratorCapacity(batteryVoltage);
      break;
    default:
      capacity = calculateDefaultCapacity(batteryVoltage);
      break;
  }

  return `${capacity}%`;
};

export { getBatteryState };
